import React, { useEffect, useRef } from 'react';
import { Box, Typography } from '@mui/material';
import { Search } from '@mui/icons-material';
import { MiniPanelProps, ExpandedPanelProps } from '../../../../types/steps';
import MiniPanel from './MiniPanel';
import ExpandedPanel from './ExpandedPanel';
import { attachGeoSearch, useMap } from '../../../../state/map';
import { useAppDispatch } from '../../../../state/types';

export const LocationMiniPanel: React.FC<MiniPanelProps> = ({ isActive, onExpand }) => {
  return (
    <MiniPanel isActive={isActive} onExpand={onExpand}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant="body2" sx={{ flex: 1, color: 'text.secondary' }}>
          <Search sx={{ mr: 1, verticalAlign: 'middle' }} fontSize="small" />
          Tap to search location
        </Typography>
      </Box>
    </MiniPanel>
  );
};

export const LocationExpandedPanel: React.FC<ExpandedPanelProps> = ({ 
  isActive, 
  onMinimize, 
  onClose 
}) => {
  const map = useMap();
  const dispatch = useAppDispatch();
  const searchRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (map && searchRef.current && isActive) {
      // Small delay to ensure DOM is ready
      const timer = setTimeout(() => {
        if (searchRef.current) {
          dispatch(attachGeoSearch(searchRef.current));
        }
      }, 100);
      
      return () => clearTimeout(timer);
    }
  }, [map, isActive, dispatch]);

  return (
    <ExpandedPanel 
      isActive={isActive} 
      onMinimize={onMinimize} 
      onClose={onClose}
      title="Search Location"
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        {/* Mapbox Geocoder will be injected here */}
        <Box 
          ref={searchRef} 
          sx={{ 
            width: '100%',
            position: 'relative',
            '& .mapboxgl-ctrl-geocoder': {
              maxWidth: 'none',
              width: '100%',
              boxShadow: 'none',
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: '12px'
            },
            '& .mapboxgl-ctrl-geocoder .suggestions': {
              position: 'absolute',
              top: '100%',
              left: 0,
              right: 0,
              zIndex: 9999,
              maxHeight: '200px',
              overflowY: 'auto',
              backgroundColor: 'white',
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: '8px',
              marginTop: '4px',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
            }
          }} 
        />
        {/* Empty space to ensure search results have room to display */}
        <Box sx={{ height: '220px' }} />
      </Box>
    </ExpandedPanel>
  );
};
